import React, { Component } from "react";
import PropTypes from "prop-types";
import ButtonPrompt from "./ButtonPrompt";

import PolicyCardArt from "./PolicyCardArt";
import PolicyFolderArt from "./PolicyFolderArt";

import "./PolicyEnactedAlert.css";
import "./Prompts.css";

class PolicyEnactedAlert extends Component {
  shiftAnimationTimeout;
  flipAnimationTimeout;

  constructor(props) {
    super(props);
    this.state = {
      className: "",
    };
  }

  componentDidMount() {
    // Set up animations
    this.shiftAnimationTimeout = setTimeout(() => {
      this.setState({ className: "show-policy-shift" });
    }, 500);
    this.flipAnimationTimeout = setTimeout(() => {
      this.setState({ className: "show-policy-flip show-policy-shift" });
    }, 1000);
  }

  componentWillUnmount() {
    clearTimeout(this.shiftAnimationTimeout);
    clearTimeout(this.flipAnimationTimeout);
  }

  render() {
    return (
      <ButtonPrompt
        renderLabel={() => {
          return (
            <div className="pp">
              <div className="pp-kicker">Legislative session</div>
              <div className="pp-title">Policy enacted</div>
            </div>
          );
        }}
        renderButton={() => (
          <div className="pp">
            <div className="pp-actions">
              <button id="prompt-button" className="gold-button pp-btn" onClick={this.props.hideAlert}>
                <span className="gold-label">OKAY</span>
              </button>
            </div>
          </div>
        )}
      >
        <div id={"policy-enacted-container"}>
          <PolicyFolderArt id={"policy-enacted-back"} className={this.state.className} part="back" />
          <PolicyCardArt
            id={"policy-enacted-policy"}
            className={this.state.className}
            policy={this.props.policyType}
            inset
          />
          <PolicyFolderArt id={"policy-enacted-cover-back"} className={this.state.className} part="coverBack" />
          <PolicyFolderArt id={"policy-enacted-cover-front"} className={this.state.className} part="coverFront" />
        </div>
      </ButtonPrompt>
    );
  }
}

PolicyEnactedAlert.propTypes = {
  hideAlert: PropTypes.func.isRequired,
  policyType: PropTypes.string.isRequired,
};

export default PolicyEnactedAlert;
